import {
    postInvoiceDocumentProviderLoading,
    postInvoiceDocumentProviderRequest,
    postInvoiceDocumentProviderSuccess,
    postInvoiceDocumentProviderReject,
    postInvoiceDocumentProviderReset
} from "../../actions/invoiceProvider/postInvoiceDocument";

export const postInvoiceDocumentProvider = (formData) => async (dispatch, getState) => {
    dispatch(postInvoiceDocumentProviderLoading());
    try {
        const { data } = await postInvoiceDocumentProviderRequest(formData, getState);
        dispatch(postInvoiceDocumentProviderSuccess(data))
    } catch (error) {
        dispatch(postInvoiceDocumentProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(postInvoiceDocumentProviderReset()) }, 3000);
    }
    return Promise.resolve();
};